// Este codigo fue generado por Github Copilot Chat
import {
  Component,
  forwardRef,
  Input,
  Output,
  EventEmitter,
  OnInit
} from '@angular/core';
import { ReactiveFormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AbstractControlValueAccessorComponent } from '../../helpers/abstract-control-value-accessor';

@Component({
  selector: 'app-input-check',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './input-check.component.html',
  styleUrls: ['./input-check.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputCheckComponent),
      multi: true
    }
  ]
})
export class InputCheckComponent
  extends AbstractControlValueAccessorComponent<boolean>
  implements OnInit
{
  /**
   * Standalone mode: checked state (when not using FormControl)
   */
  @Input() checked = false;

  /**
   * Standalone mode: disabled state (when not using FormControl)
   */
  @Input() disabled = false;

  /**
   * Show border around checkbox container
   */
  @Input() showBorder = true;

  /**
   * Event emitted when checkbox changes in standalone mode
   */
  @Output() checkedChange = new EventEmitter<boolean>();

  /**
   * Track if formControl was provided externally
   */
  private wasFormControlProvided = false;

  /**
   * Check if component is in standalone mode (not using FormControl)
   */
  get isStandaloneMode(): boolean {
    // If formControl was explicitly provided via @Input, use FormControl mode
    // Otherwise, use standalone mode with [checked] binding
    return !this.wasFormControlProvided;
  }

  ngOnInit(): void {
    // Check if formControl was provided externally by checking if it has subscribers or validators
    // or if it's not the default empty FormControl
    this.wasFormControlProvided =
      this.formControl.parent !== null ||
      this.formControl.validator !== null ||
      this.formControl.asyncValidator !== null ||
      this.formControl.value !== null;
  }

  /**
   * Handle change event in standalone mode
   */
  onStandaloneChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.checkedChange.emit(target.checked);
  }
}
// Este codigo fue generado por Github Copilot Chat
